import './Style.scss';
import { Divider } from 'primereact/divider';
import { useDispatch } from 'react-redux';
import { setStyle } from '../../../../features/sharedSlice';
import { useAppSelector } from '../../../../store/hooks';
import { selectServices } from '../../../../features/layerSlice';
import Legend from '../Legend/Legend';

export const Style = () => {
  const dispatch = useDispatch();
  const services = useAppSelector(selectServices);
  const style = useAppSelector(state => state.sharedState.style)
  const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
  const activeLanguage = useAppSelector(state => state.language.activeLanguage);

  const legendClicked = (legendName: string) => {
    dispatch(setStyle(legendName))
  }

  return (
    <>
      {services &&
        services.find(obj => obj.type === 'VECTOR' && obj.layers.length > 0)?.
          layers.find(layer => layer.name === 'parsel_usr')?.visible &&
        <>
          <Legend style={style} url={services.find(obj => obj.type === 'VECTOR')?.url}></Legend>
          {functionalRoles.findIndex((role: any) => role.function_id === 17) > -1 && <div className={`${activeLanguage === 'tr' ? 'legend-container' : 'legend-container2'}`}>
            <div className='text' onClick={() => legendClicked('imar_durumu')}>{activeLanguage === 'tr' ? 'İmar Durumu' : 'Reconstruction Situation'}</div>
            <div style={{ height: '30px' }}>
              <Divider type='dashed' layout="vertical" align='center'></Divider>
            </div>
            <div className='text' onClick={() => legendClicked('parsel_niteligi')}>{activeLanguage === 'tr' ? 'Parsel Niteliği' : 'Parcel Qualification'}</div>
            <div style={{ height: '30px' }}>
              <Divider type='dashed' layout="vertical" align='center'></Divider>
            </div>
            <div className='text' onClick={() => legendClicked('parsel_usr')}>{activeLanguage === 'tr' ? 'Tahsis Durumu' : 'Allocation Situation'}</div>
            <div style={{ height: '30px' }}>
              <Divider type='dashed' layout="vertical" align='center'></Divider>
            </div>
            <div className='text' onClick={() => legendClicked('asamasi')}>{activeLanguage === 'tr' ? 'Aşaması' : 'Phase'}</div>
            <div className='text' onClick={() => legendClicked('duzenlenecek_parsel')}>{activeLanguage === 'tr' ? 'Parsel Güncelle' : 'Edit Parcel'}</div>
          </div>}
        </>

      }
    </>

  )
}
